import { Button } from '@components/button';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { MerchantUser } from '@root/globalTypes';
import { Mail } from 'lucide-react';

type ResendInvitationBtnProps = {
  user: MerchantUser;
  onResend: (id: string) => void;
};

export function ResendMerchantUserInvitationButton({ user, onResend }: ResendInvitationBtnProps) {
  const { verifyUserPermission } = useCheckUserPermissions();

  if (
    !verifyUserPermission(`merchant_users_update`) ||
    !user.invitationSentAt ||
    user.invitationAcceptedAt
  ) {
    return null;
  }

  return (
    <Button
      size="sm"
      className="w-14"
      variant="outline"
      type="button"
      onClick={() => onResend(user.id)}>
      <Mail className="h-5" />
    </Button>
  );
}
